import * as S from "./styles";

/**
 * Contador de caracteres de um campo com limite.
 *
 * Existe para o usuário entender ANTES de salvar por que o campo não passa: o
 * Resumo do Projeto tem teto de 930 caracteres (é o que cabe no slide da
 * apresentação da seletiva) e há projetos antigos bem acima disso — sem o
 * contador, a recusa do backend viria sem pista do tamanho atual.
 */
const CharCounter = ({ value, max, variant = "dark" }) => {
  const length = String(value ?? "").length;

  return (
    <S.Counter variant={variant} exceeded={length > max}>
      {length}/{max} caracteres
    </S.Counter>
  );
};

export default CharCounter;
